import React from 'react';
import InboxIcon from 'web-ui-kit/assets/InboxIcon';
import { SecondaryListItem, ListItem, ListItemWithIcon, ListItemWithButton } from 'web-ui-kit/menus';
import get from 'lodash/get';
import { webPP, allRoutes } from 'web-ui-kit/routes';
import ReferAFriendIcon from 'web-ui-kit/assets/ReferAFriendIcon';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
* Set a list of <SecondaryListItem /> used in the Drawer.
* @return array of SecondaryListItem
*/


var setSecondaryListItemList = function setSecondaryListItemList() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dispatch = arguments.length > 1 ? arguments[1] : undefined;
  return Object.values(items).map(function (item, index) {
    var key = "".concat(item, "-").concat(index);
    return (
      /*#__PURE__*/
      React.createElement(SecondaryListItem, {
        key: key,
        dispatch: dispatch,
        label: item
      })
    );
  });
};
/**
* Set a list of <ListItem variant='two-line' isSubLevel /> used in the Drawer.
* @return array of ListItem
*/


var setSublevelTwoLineList = function setSublevelTwoLineList(_ref) {
  var _ref$projects = _ref.projects,
      projects = _ref$projects === void 0 ? [] : _ref$projects,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch;
  return projects.filter(function (project) {
    return project.id !== START_NEW_PROJECT_ID;
  }) // exclude "Start New Project" cell
  .map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        status = _ref2.status,
        _ref2$slug = _ref2.slug,
        slug = _ref2$slug === void 0 ? '' : _ref2$slug,
        _ref2$projectDetails = _ref2.projectDetails,
        projectDetails = _ref2$projectDetails === void 0 ? {} : _ref2$projectDetails;
    var key = "".concat(id, "-").concat(name);
    return (
      /*#__PURE__*/
      React.createElement(ListItem, {
        key: key,
        dispatch: dispatch,
        isSubLevel: true,
        label: name,
        projectDetails: _objectSpread2(_objectSpread2({}, projectDetails), {}, {
          isUserProject: projectDetails.isUserProject || !!slug,
          projectSlug: slug
        }),
        subLabel: status,
        variant: 'two-line'
      })
    );
  });
};
/**
* Set a list of <ListItem variant='one-line' isSubLevel /> used in the Drawer.
* @return array of ListItem
*/


var setSublevelOneLineList = function setSublevelOneLineList() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  return Object.values(items).map(function (item, index) {
    var key = "".concat(item, "-").concat(index);
    return (
      /*#__PURE__*/
      React.createElement(ListItem, {
        key: key,
        dispatch: dispatch,
        label: item,
        isSubLevel: true
      })
    );
  });
};
/**
* Set a list of <ListItem variant='one-line' />.
* @return array of ListItem
*/


var setDropdownSingleLineList = function setDropdownSingleLineList() {
  var labelList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  return Object.values(labelList).map(function (label, index) {
    var key = "".concat(label, "-").concat(index);
    return (
      /*#__PURE__*/
      React.createElement(ListItem, {
        key: key,
        dispatch: dispatch,
        label: label
      })
    );
  });
};
/**
* Set a list composed of both <ListItem variant='one-line' /> + <ListItemWithButton />.
* @return array of List items
*/


var setDropdownSingleLineListAndButton = function setDropdownSingleLineListAndButton(_ref3) {
  var _ref3$labelList = _ref3.labelList,
      labelList = _ref3$labelList === void 0 ? {} : _ref3$labelList,
      _ref3$buttonData = _ref3.buttonData,
      buttonData = _ref3$buttonData === void 0 ? {} : _ref3$buttonData,
      _ref3$dispatch = _ref3.dispatch,
      dispatch = _ref3$dispatch === void 0 ? function () {} : _ref3$dispatch;
  var mainList = setDropdownSingleLineList(labelList, dispatch);
  return [].concat(_toConsumableArray(mainList), [
  /*#__PURE__*/
  React.createElement(ListItemWithButton, {
    dispatch: dispatch,
    buttonData: buttonData
  })]);
};
/**
 * Set a list of <ListItem variant='two-line' /> and optionally
 * adds a single <ListItem /> at the end.
 * @return array of ListItem
 */


var setDropdownTwoLineList = function setDropdownTwoLineList(_ref4) {
  var _ref4$projects = _ref4.projects,
      projects = _ref4$projects === void 0 ? [] : _ref4$projects,
      _ref4$dispatch = _ref4.dispatch,
      dispatch = _ref4$dispatch === void 0 ? function () {} : _ref4$dispatch; // Let's intercept the last cell if it's "Start New Project".

  var lastListItemID = get(projects[projects.length - 1], 'id', '');
  var hasStartNewProject = lastListItemID === START_NEW_PROJECT_ID;
  var allProjectListItems = projects.filter(function (project) {
    return project.id !== START_NEW_PROJECT_ID;
  }) // exclude "Start New Project" cell
  .map(function (_ref5) {
    var id = _ref5.id,
        name = _ref5.name,
        status = _ref5.status,
        _ref5$slug = _ref5.slug,
        slug = _ref5$slug === void 0 ? '' : _ref5$slug,
        _ref5$projectDetails = _ref5.projectDetails,
        projectDetails = _ref5$projectDetails === void 0 ? {} : _ref5$projectDetails;
    var key = "".concat(id, "-").concat(name);
    var isUserProject = projectDetails.isUserProject || !!slug;
    return (
      /*#__PURE__*/
      React.createElement(ListItem, {
        key: key,
        dispatch: dispatch,
        label: name,
        projectDetails: _objectSpread2(_objectSpread2({}, projectDetails), {}, {
          isUserProject: isUserProject,
          projectSlug: slug
        }),
        subLabel: status,
        variant: "two-line"
      })
    );
  });
  return hasStartNewProject ? [].concat(_toConsumableArray(allProjectListItems), [
  /*#__PURE__*/
  React.createElement(ListItem, {
    key: "start-your-project-list-item",
    dispatch: dispatch,
    label: "Start New Project",
    projectDetails: {
      isUserProject: true,
      projectSlug: webPP.projectOnboarding()
    }
  })]) : allProjectListItems;
};
/**
 * Set a list composed of both <ListItem variant='one-line' /> + <ListItemWithIcon />.
 * @return array of List items
 */


var setDropdownSingleLineListAndIcon = function setDropdownSingleLineListAndIcon(_ref6) {
  var _ref6$labelList = _ref6.labelList,
      labelList = _ref6$labelList === void 0 ? {} : _ref6$labelList,
      _ref6$Icon = _ref6.Icon,
      Icon = _ref6$Icon === void 0 ? {} : _ref6$Icon,
      _ref6$label = _ref6.label,
      label = _ref6$label === void 0 ? '' : _ref6$label,
      _ref6$title = _ref6.title,
      title = _ref6$title === void 0 ? '' : _ref6$title,
      _ref6$dispatch = _ref6.dispatch,
      dispatch = _ref6$dispatch === void 0 ? function () {} : _ref6$dispatch;
  var mainList = setDropdownSingleLineList(labelList, dispatch);
  return [].concat(_toConsumableArray(mainList), [
  /*#__PURE__*/
  React.createElement(ListItemWithIcon, {
    dispatch: dispatch,
    Icon: Icon,
    label: label,
    title: title
  })]);
};
/**
 * How It Works data
 */


var HOW_IT_WORKS_DROPDOWN_LABELS = {
  MODSY_VS_TRADITIONAL: 'Modsy vs. Traditional Designers',
  DIFFERENCE: 'The Modsy 3D Difference',
  DESIGN_SERVICE: 'Design Service Q&A',
  INTERIOR_DESIGN_101: 'Interior Design 101'
};

var HOW_IT_WORKS_DRAWER_LABELS = _objectSpread2({
  HOW_IT_WORKS_HOME: 'How It Works'
}, HOW_IT_WORKS_DROPDOWN_LABELS);

var DROPDOWN_HOW_IT_WORKS_LIST = function DROPDOWN_HOW_IT_WORKS_LIST(dispatch) {
  return setDropdownSingleLineList(HOW_IT_WORKS_DROPDOWN_LABELS, dispatch);
};
/**
 * Blog data
 */


var BLOG_DROPDOWN_LABELS = {
  TIPS: 'Tips & Guides',
  REAL_STORIES: 'Real Stories',
  INSPIRATION: 'Style Inspiration',
  LAYOUT: 'Layout Guides',
  MODSY_101: 'Modsy 101'
};

var BLOG_DRAWER_LABELS = _objectSpread2({
  BLOG_HOME: 'Blog Home'
}, BLOG_DROPDOWN_LABELS);

var DROPDOWN_BLOG_LIST = function DROPDOWN_BLOG_LIST(dispatch) {
  return setDropdownSingleLineList(BLOG_DROPDOWN_LABELS, dispatch);
};
/**
 * Design Ideas data
 */


var DESIGN_IDEAS_DROPDOWN_LABELS = {
  BEDROOM: 'Bedroom Design Ideas',
  DINING: 'Dining Room Design Ideas',
  OFFICE: 'Home Office Design Ideas',
  KIDS: "Kid's Bedroom Design Ideas",
  LIVING_ROOM: 'Living Room Design Ideas'
};

var DESIGN_IDEAS_DRAWER_LABELS = _objectSpread2({
  ALL: 'All Design Ideas'
}, DESIGN_IDEAS_DROPDOWN_LABELS);

var DROPDOWN_DESIGN_IDEAS_LIST = function DROPDOWN_DESIGN_IDEAS_LIST(dispatch) {
  return setDropdownSingleLineList(DESIGN_IDEAS_DROPDOWN_LABELS, dispatch);
};
/**
 * Account data
 */


var ACCOUNT_DROPDOWN_LABELS_WITH_HELP = {
  ACCOUNT: 'Accounts Settings',
  HISTORY: 'Order History',
  HELP: 'Help',
  LOGOUT: 'Logout'
};
var ACCOUNT_DROPDOWN_LABELS = {
  ACCOUNT: 'Accounts Settings',
  HISTORY: 'Order History',
  LOGOUT: 'Logout'
};
var ACCOUNT_DRAWER_LABELS = {
  ACCOUNT: 'My Account',
  HISTORY: 'Order History',
  HELP: 'Help',
  LOGOUT: 'Logout'
};
/**
 * Help data
 */

var HELP_DROPDOWN_LABELS = {
  HELP_CENTER: 'Help Center',
  GETTING_STARTED_WITH_MODSY: 'Getting Started - Your Designs Page',
  USING_3D_EDITOR: 'Using the Modsy 3D Editor'
};

var HELP_MODAL_PROPS = function HELP_MODAL_PROPS() {
  return {
    buttons: [{
      id: 'get-in-touch-button',
      label: 'Get In Touch',
      Icon:
      /*#__PURE__*/
      React.createElement(InboxIcon, {
        variant: "primary"
      }),
      description: 'Get in touch with Modsy Support'
    }],
    links: Object.keys(HELP_DROPDOWN_LABELS).map(function (key, id) {
      return {
        id: key,
        label: HELP_DROPDOWN_LABELS[key],
        route: allRoutes[HELP_DROPDOWN_LABELS[key]]
      };
    }),
    title: 'Help'
  };
};

var LOGGED_OUT_LABELS = {
  LOGIN: 'Login',
  START_NEW_PROJECT: 'Start New Project'
};
var PROJECT_SUB_LABELS = {
  TELL_US_MORE: 'Tell us more about your project',
  SELECT_LAYOUT: 'Select a layout',
  ONE_NEW_DESIGN_READY: 'New design ready!',
  SOME_NEW_DESIGNS_READY: 'New designs ready!',
  DESIGN_READY: 'Designs ready - View, Edit',
  WORKING_ON_DESIGNS: "We're working on your designs now",
  REVIEWING_PROJECT: "We're reviewing your project now",
  WORKING_ON_PROJECT: "We're working on your project now",
  NEW_MESSAGE: 'New message'
};
var HEADER_NAMES = {
  MY_PROJECTS: 'My Projects',
  PROJECTS: 'Projects',
  MODSY_PRO: 'Modsy Pro',
  HOW_IT_WORKS: 'How It Works',
  PRICING: 'Pricing',
  EXAMPLES: 'Examples',
  BEFORE_AND_AFTER: 'Before & After',
  GIFT_CARDS: 'Gift Cards',
  STYLE_QUIZ: 'Style Quiz',
  DESIGN_IDEAS: 'Design Ideas',
  IDEAS: 'Ideas',
  BLOG: 'Blog',
  ACCOUNT: 'Account',
  LOGIN: 'Login',
  START_YOUR_PROJECT: 'Start Your Project',
  HELP: 'Help'
};

var DROPDOWN_ACCOUNT_LIST_WITH_HELP = function DROPDOWN_ACCOUNT_LIST_WITH_HELP(dispatch) {
  return setDropdownSingleLineList(ACCOUNT_DROPDOWN_LABELS_WITH_HELP, dispatch);
};

var DROPDOWN_ACCOUNT_LIST = function DROPDOWN_ACCOUNT_LIST(dispatch) {
  return setDropdownSingleLineListAndIcon({
    labelList: ACCOUNT_DROPDOWN_LABELS,
    Icon:
    /*#__PURE__*/
    React.createElement(ReferAFriendIcon, null),
    title: 'Refer a Friend, Get 50% Off',
    label: 'referrals',
    dispatch: dispatch
  });
};

var DROPDOWN_HELP_LIST = function DROPDOWN_HELP_LIST(dispatch) {
  return setDropdownSingleLineListAndButton({
    labelList: HELP_DROPDOWN_LABELS,
    buttonData: {
      content: 'Get In Touch',
      subtitle: 'Get in touch with Modsy Support',
      fluid: true,
      size: 'small'
    },
    dispatch: dispatch
  });
};

var START_NEW_PROJECT_ID = 'start new project';
var MODSY_LUXE_PREFIX = 'LUXE_';
export { ACCOUNT_DRAWER_LABELS, ACCOUNT_DROPDOWN_LABELS, ACCOUNT_DROPDOWN_LABELS_WITH_HELP, BLOG_DRAWER_LABELS, BLOG_DROPDOWN_LABELS, DESIGN_IDEAS_DRAWER_LABELS, DESIGN_IDEAS_DROPDOWN_LABELS, DROPDOWN_ACCOUNT_LIST, DROPDOWN_ACCOUNT_LIST_WITH_HELP, DROPDOWN_BLOG_LIST, DROPDOWN_DESIGN_IDEAS_LIST, DROPDOWN_HELP_LIST, DROPDOWN_HOW_IT_WORKS_LIST, HEADER_NAMES, HELP_DROPDOWN_LABELS, HELP_MODAL_PROPS, HOW_IT_WORKS_DRAWER_LABELS, HOW_IT_WORKS_DROPDOWN_LABELS, LOGGED_OUT_LABELS, MODSY_LUXE_PREFIX, PROJECT_SUB_LABELS, START_NEW_PROJECT_ID, setDropdownTwoLineList, setSecondaryListItemList, setSublevelOneLineList, setSublevelTwoLineList };